
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHomeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  viewBox: "0 0 44 44",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 31.833a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75ZM21.999 23.917a7.81 7.81 0 0 0-5.364 2.135 1.013 1.013 0 0 0 0 1.47 1.115 1.115 0 0 0 1.528 0 5.53 5.53 0 0 1 3.836-1.531c1.44 0 2.82.55 3.836 1.53.2.196.473.309.758.313.45.024.87-.221 1.053-.617.183-.396.092-.86-.229-1.165a7.812 7.812 0 0 0-5.418-2.135Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 19.75c-3.16.008-6.19 1.213-8.431 3.354a1.017 1.017 0 0 0 0 1.48 1.12 1.12 0 0 0 1.538 0c3.808-3.656 9.976-3.656 13.784 0 .204.194.481.303.77.301.287.002.564-.107.768-.302.206-.195.321-.461.321-.74 0-.277-.115-.543-.32-.739-2.242-2.14-5.271-3.346-8.43-3.354Z",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M37 38V19.813c0-.386-.162-.754-.446-1.013L22.916 6.356a1.36 1.36 0 0 0-1.834 0L7.446 18.8c-.284.26-.446.627-.446 1.012V38M4 38h36",
  stroke: "#000",
  strokeWidth: 2.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"80\" height=\"80\" viewBox=\"0 0 44 44\" fill=\"none\">\r\n  <path d=\"M22 31.8331C20.9645 31.8331 20.125 30.9937 20.125 29.9581C20.125 28.9226 20.9645 28.0831 22 28.0831C23.0355 28.0831 23.875 28.9226 23.875 29.9581C23.875 30.9937 23.0355 31.8331 22 31.8331Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  <path d=\"M21.999 23.9169C19.9886 23.9236 18.0618 24.6907 16.6352 26.0523C16.215 26.4586 16.215 27.1148 16.6352 27.5211C17.0578 27.925 17.7404 27.925 18.163 27.5211C19.1795 26.5415 20.5597 25.9909 21.999 25.9909C23.4383 25.9909 24.8184 26.5415 25.8349 27.5211C26.035 27.7173 26.3076 27.8297 26.5934 27.8336C27.0436 27.8585 27.4628 27.6128 27.6459 27.2167C27.829 26.8206 27.7379 26.3569 27.417 26.0523C25.977 24.678 24.0281 23.9098 21.999 23.9169Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  <path d=\"M21.9991 19.75C18.8393 19.7581 15.8102 20.9632 13.5687 23.1042C13.1438 23.5126 13.1438 24.1749 13.5687 24.5833C13.9936 24.9918 14.6825 24.9918 15.1074 24.5833C18.9149 20.9277 25.0832 20.9277 28.8907 24.5833C29.0952 24.7783 29.3721 24.887 29.6601 24.8854C29.9481 24.887 30.2249 24.7783 30.4294 24.5833C30.6346 24.3877 30.75 24.1215 30.75 23.8437C30.75 23.566 30.6346 23.2997 30.4294 23.1042C28.1879 20.9632 25.1588 19.7581 21.9991 19.75Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  <path d=\"M37 38V19.8126C37 19.427 36.8379 19.0593 36.5537 18.7999L22.9164 6.35596C22.3962 5.88132 21.6018 5.88135 21.0817 6.35602L7.44627 18.7999C7.16204 19.0593 7 19.427 7 19.8125V38\" stroke=\"#000000\" stroke-width=\"2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <path d=\"M4 38H40\" stroke=\"#000000\" stroke-width=\"2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/home-icon.b0f67370bda13b53023119fbfe0c7697.svg"),
        {
          React: SvgHomeIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      